<template>
  <div class="dashboard-month-page">
    <calendar
      :tasks="tasks"
      :holidays="holidays"
    />
  </div>
</template>

<script>
import Calendar from '@/components/dashboard/month-page/calendar'

export default {
  props: ['stickers', 'tasks', 'holidays', 'stats'],
  components: {
    Calendar
  }
}
</script>

<style>

</style>
